import { useQuery } from '@tanstack/react-query'

import { StorePersistKeys } from 'src/types'

import { getModelsForMake } from 'src/api/AutoInfo'

export const useCarModels = (brand: string) => {
  const { data: modelsForMake, isLoading: isLoadingGetModelsForMake } =
    useQuery({
      queryKey: [StorePersistKeys.MODELS_FOR_MAKE, brand],
      queryFn: () => getModelsForMake(brand),
      enabled: !!brand,
    })

  return {
    modelsForMake,
    isLoadingGetModelsForMake,
  }
}
